import script from "./AppTagSelectorList.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTagSelectorList.vue?vue&type=script&setup=true&lang=ts"

import "./AppTagSelectorList.vue?vue&type=style&index=0&id=252e7f0e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-252e7f0e"]])

export default __exports__